import { useMemo } from 'react'
import { useHistory } from 'react-router'
import { useUrlSearch } from '@/hooks'

/**

 * @param queryKey 参数在路由 search 部分中的名称, 默认为: `t`
 * @description
 * 该钩子主要用于携带信息跳转页面;
 * 路径由调用发确定, 钩子只会在路由后面添加 search 参数
 */
export const useSessionStorage = <T = any>(queryKey = 't') => {
  const params = useUrlSearch()
  const token = useMemo(() => params[queryKey], [params, queryKey])
  const history = useHistory()

  const sessionStorage = useMemo(() => {
    class C {
      token?: string
      constructor() {
        this.token = token
      }
      get() {
        const { localStorage, sessionStorage } = window
        const source = localStorage.getItem(this.token) || sessionStorage.getItem(this.token)

        if (source) {
          try {
            const orderInfo = JSON.parse(source)
            localStorage.removeItem(this.token)

            sessionStorage.setItem(this.token, source)
            return orderInfo
          } catch (error) {
            return null
          }
        }

        return null
      }
      set(value: T) {
        const token = (Date.now() + Math.floor(Math.random() * 1e9)).toString(32)
        this.token = token
        const source = JSON.stringify(value)
        localStorage.setItem(token, source)
        return this
      }
      mapTokenToUrl(url: string) {
        const hIndex = url.indexOf('#')
        const hash = hIndex !== -1 ? url.substring(hIndex) : ''
        const head = hash ? url.replace(hash, '') : url
        const tail = `${queryKey}=${this.token}${hash}`
        const newUrl = `${head}${-1 !== url.indexOf('?') ? '&' : '?'}${tail}`
        history.push(newUrl)
      }
    }

    return new C()
  }, [history, queryKey, token])

  return { sessionStorage }
}
